import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorMessage: {
		id: 'servicedesk-sla-settings.calendars.editable.error-message',
		defaultMessage: 'Something has gone wrong. An error has occurred.',
		description: 'error message displayed when calendar modification fails',
	},
	otherProjectCalendarsCopy: {
		id: 'servicedesk-sla-settings.calendars.editable.other-project-calendars-copy',
		defaultMessage: 'Copy of {calendarName} (from {serviceDeskName})',
		description:
			'label that appears when in the calendar edit form when a calendar of the other serviceDesk project is copied',
	},
	currentProjectCalendarsCopy: {
		id: 'servicedesk-sla-settings.calendars.editable.current-project-calendars-copy',
		defaultMessage: 'Copy of {calendarName}',
		description:
			'label that appears in the calendar edit form when a calendar of the current serviceDesk project is copied',
	},
});
